const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'ctype_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_CTYPES':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_CTYPES':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_CTYPES':
      return {
        ...state,
        search: action.search
      }
    case 'FILTER_CTYPES':
      return {
        ...state,
        filter: action.filter
      }
    case 'EDIT_CTYPE':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.ctype_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ctypes.js